module.exports = __webpack_public_path__ + "static/img/money-explain1.ffd06285.png";